import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ww-checkbox-multiple-select" }
const _hoisted_2 = { class: "ww-button-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
      return (_openBlock(), _createBlock(_component_Checkbox, {
        key: index,
        value: _ctx.checkIsChecked(item),
        label: item.title,
        onOnChange: (value) => _ctx.handleUpdateArray(item, value)
      }, null, 8, ["value", "label", "onOnChange"]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        text: _ctx.$t('button.checkAll'),
        dense: true,
        onOnClick: _ctx.handleCheckAll
      }, null, 8, ["text", "onOnClick"]),
      _hoisted_3,
      _createVNode(_component_Button, {
        text: _ctx.$t('button.reset'),
        dense: true,
        onOnClick: _ctx.handleUnCheckAll
      }, null, 8, ["text", "onOnClick"])
    ])
  ]))
}